module.exports = __webpack_public_path__ + "static/media/account.a0b62d50.svg";